var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9647_19306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7407 15.5658V20.4553H27.0337V11.8787C27.0337 8.94348 29.4141 6.5625 32.3499 6.5625H44.5789C46.5308 6.5625 48.324 7.63123 49.2529 9.34632L50.9265 12.4335C51.9733 14.364 53.9923 15.5658 56.1865 15.5658H61.7407Z",
    fill: "#F1706C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.308 18.3784L27.5409 9.61133C27.2162 10.2992 27.0337 11.0676 27.0337 11.8788V20.4555H38.3844L36.308 18.3784Z",
    fill: "url(#paint0_linear_9647_19306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0565 12.4335L27.3836 9.34631C26.454 7.63123 24.6602 6.5625 22.7095 6.5625H10.4793C7.54346 6.5625 5.16309 8.94287 5.16309 11.8787V68.2764C5.16309 71.2122 7.54346 73.5919 10.4793 73.5919H74.6846C77.6204 73.5919 80.0002 71.2122 80.0002 68.2764V20.882C80.0002 17.9462 77.6204 15.5664 74.6846 15.5664H34.3172C32.1217 15.5664 30.1027 14.364 29.0565 12.4335Z",
    fill: "#89C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4793 73.5919H74.6846C77.6204 73.5919 80.0002 71.2122 80.0002 68.2764V28.3136L72.4916 20.8051L49.2757 20.6348C48.3699 22.3059 46.6218 23.3472 44.7206 23.3472H9.76636C7.22424 23.3472 5.16309 25.4083 5.16309 27.9504V68.2764C5.16309 71.2122 7.54346 73.5919 10.4793 73.5919Z",
    fill: "#6FB4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0572 30.1196C74.0572 22.0819 67.5417 15.5664 59.5045 15.5664H34.3172C32.1217 15.5664 30.1027 14.364 29.0565 12.4335L27.3829 9.3457C26.454 7.63062 24.6602 6.5625 22.7095 6.5625H10.4793C7.54346 6.5625 5.16309 8.94226 5.16309 11.8781V30.119H74.0572V30.1196Z",
    fill: "#89C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1144 23.6045V70.4429C74.1144 71.8437 73.2007 73.0308 71.9355 73.4397C71.6291 73.5386 71.3037 73.5923 70.965 73.5923H10.4041C8.66516 73.5923 7.25464 72.1824 7.25464 70.4429V23.6045C7.25464 21.865 8.66516 20.4551 10.4041 20.4551H70.965C72.7039 20.4551 74.1144 21.865 74.1144 23.6045Z",
    fill: "url(#paint1_linear_9647_19306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1144 36.1808V70.4429C74.1144 71.8437 73.2007 73.0308 71.9354 73.4397L48.7946 50.2988C45.7489 47.3606 43.6237 28.7339 42.8931 24.376H60.6323C61.8793 24.376 63.0078 24.9363 63.7653 25.8304L74.1144 36.1808Z",
    fill: "url(#paint2_linear_9647_19306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.684 73.5923H9.76694C7.2236 73.5923 5.16367 71.5305 5.16367 68.989L0.0342683 29.0024C-0.280673 26.5488 1.63095 24.376 4.10471 24.376H60.6318C62.696 24.376 64.4392 25.9092 64.7023 27.9569L69.9647 68.8719C69.9647 71.4793 72.0778 73.5923 74.684 73.5923Z",
    fill: "#A5D2FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9647_19306",
    x1: 33.0186,
    y1: 20.7645,
    x2: 20.3025,
    y2: 8.04842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0084",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0737,
    stopColor: "#F4087E",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3347,
    stopColor: "#D2216B",
    stopOpacity: 0.333333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#BA335E",
    stopOpacity: 0.584314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#AB3D56",
    stopOpacity: 0.811765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9647_19306",
    x1: 31.5141,
    y1: 30.5167,
    x2: 60.754,
    y2: 83.1486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9647_19306",
    x1: 79.8577,
    y1: 49.4401,
    x2: 50.8705,
    y2: 48.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#C2E0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#BFDCFD",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EB2E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9647_19306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFolder);
export default __webpack_public_path__ + "static/media/new-folder.0871d2676274e4cab7a31345439f98c6.svg";
export { ForwardRef as ReactComponent };